import type { CardPlacementDeps } from './drag-create-content';

/**
 * Runs one conversion batch against a loaded scene with the real scene executor and the real Excalidraw library, both behind
 * the lazy boundary of `@frontendlib/boards-canvas` (`executeHeadlessBatch`): loaded on the first Drag to create that needs a
 * card, nothing of them in the initial bundle. Importing the scene library from here would make every static import of it in
 * the app a lazy-library violation, so the app only ever names the boundary.
 */
export const executeInRuntime: CardPlacementDeps['execute'] = async (scene, batch, items) => {
  const { executeHeadlessBatch } = await import('@frontendlib/boards-canvas');
  return executeHeadlessBatch(scene, batch, items);
};
